module.exports = __webpack_public_path__ + "static/img/no-goods.7707e335.png";